import { Validators } from '@angular/forms';
import { INPUT_TYPES_CONFIG } from '../products.config';
import { vehicleChassisProperty, vehicleFuelTypeInput, vehicleRegistryInput, vehicleRegistryProperty } from '../vehicle-registry.config';

export const MOPED = {
  nickname: 'PRODUCTS.MOPED.shortname',
  vehicleRegistryMode: true,
  properties: [
    {
      name: 'calculatedClientAge', key: 'CLIENT_AGE', group: 'OBJECT_INFO',
      inputType: INPUT_TYPES_CONFIG.TEL,
      validator: ['', [
        Validators.pattern(/^\d+$/)
      ]]
    },
    {
      name: 'vehicleLicenseNumber', key: 'LICENSE_NUMBER', group: 'OBJECT_INFO',
      MOPED: true,
      inputType: INPUT_TYPES_CONFIG.STRING,
      validator: ['', [
        Validators.required,
        Validators.pattern(/[a-zA-Z]{2}\d{4}/)
      ]]
    },
    { name: 'vehicleYoungDriver', key: 'YOUNG_DRIVER', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.BOOLEAN,
      validator: ['', [
        Validators.required
      ]]
    },
    {
      name: 'vehicleFuelType', key: 'VEHICLE_FUEL_TYPE', group: 'OBJECT_INFO',
      ...vehicleFuelTypeInput(5)
    },
    {
      name: 'productPackage', key: 'PRODUCT_PACKAGE', group: 'INSURANCE_INFO',
      inputType: INPUT_TYPES_CONFIG.SELECT_DATA_LIST,
      validator: ['', [
        Validators.required
      ]],
      settings: {
        list: [
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.ANSVAR', value: 'ANSVAR' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.DELKASKO', value: 'DELKASKO' },
          { key: 'PROPERTIES_FORM.SELECT_LIST.PRODUCT_PACKAGE.KASKO', value: 'KASKO' },
        ]
      }
    },
    {
      name: 'ofvBrandName', key: 'TFF_VEHICLE_BRAND', group: 'OBJECT_INFO',
      ...vehicleRegistryInput(2)
    },
    {
      name: 'ofvModelName', key: 'TFF_VEHICLE_MODEL', group: 'OBJECT_INFO',
      ...vehicleRegistryInput(3)
    },
    { name: 'ofvYearModel', key: 'REGISTRATION_YEAR_MODEL_MC', group: 'OBJECT_INFO' },
    {
      name: 'ofvSegmentName', key: 'OFV_SEGMENT_NAME', group: 'OBJECT_INFO',
      ...vehicleRegistryInput(1, { required: false })
    },
    vehicleRegistryProperty('ofvFirstTimeRegYear', 'OFV_FIRST_TIME_REG_YEAR', 4, { group: 'INSURANCE_INFO' }),
    vehicleRegistryProperty('ofvTotalHp', 'TFF_VEHICLE_ENGINE_POWER_MC', 6, { required: false }),
    vehicleRegistryProperty('ofvVehicleWeight', 'TFF_VEHICLE_WEIGHT', 7),
    vehicleRegistryProperty('ofvPrice', 'OFV_PRICE_MC', 8, { required: false }),
    vehicleChassisProperty(9),
  ],
  icon: 'motorcycle'
};
